import { useCallback } from "react";

import { useProductOptionFormModelContext } from "../../../../../context";

export const useOptionMultiSubOptionSelectable = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { multiSubOptionSelectable, useAsSubOption, subOptions } = viewModel;

	const isEdited = multiSubOptionSelectable.isEdited;
	const hasError = Boolean(subOptions?.hasError || multiSubOptionSelectable.error);

	const onSetMultiSubOptionSelectable = useCallback(
		(input: boolean) => {
			// サブオプションとして使用しない場合は、何もしない
			if (!useAsSubOption.value) return;

			onSetViewModel([
				{
					key: "multiSubOptionSelectable",
					value: {
						...multiSubOptionSelectable,
						/**
						 * 旧版のフロントで multiSubOptionSelectable を参照する際に反転させている。
						 * @see {@link https://github.com/CHILLNN-Inc/chillnn-IA-host/blob/0e4ae62cf7563e0912cc02bd9d9c3f4993cce735/host-nuxt/client/components/Organisms/Questions/QuestionSubOptions/index.vue#L104 | Host Nuxt(Github)}
						 */
						value: !input,
					},
				},
			]);
		},
		[multiSubOptionSelectable, onSetViewModel, useAsSubOption.value],
	);

	return {
		isEdited,
		hasError,

		multiSubOptionSelectable,
		onSetMultiSubOptionSelectable,
	};
};
